"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

import { createDefaultDataBindings } from "../Category/getCategoryContentBindings";

import { ATTRIBUTE_FILTERS_DRAWER_INPUTS } from "./ProductAttributeFiltersDrawer.inputs.builder";

type AttributeFiltersBindings = {
  attributeAggregations: "attributeAggregations";
  products: "categoryItems";
};

export const AttributeFiltersDrawer: RegisteredComponent = {
  name: "Attribute Filters Drawer",
  component: dynamic(async () => (await import("./ProductAttributeFiltersDrawer")).ProductAttributeFiltersDrawer),
  models: [getBuilderModelName("category")],
  defaults: {
    bindings: createDefaultDataBindings<AttributeFiltersBindings>({
      attributeAggregations: "attributeAggregations",
      products: "categoryItems",
    }),
  },
  inputs: ATTRIBUTE_FILTERS_DRAWER_INPUTS,
};
